import getApiClient from '@/plugins/api-client'

export default {
    load() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('home_videos')
            .then(result => {
                if (result.data['hydra:totalItems']) {
                    self.video = result.data['hydra:member'][0]
                }
            })
            .catch(error => {
                console.log(error)
            })
    },
    save() {
        const self = this,
            api = getApiClient(self.$store)

        if (self?.video?.id) {
            api.delete(`home_videos/${self.video.id}`)
            self.$delete(self.video, 'id')
        }
        api.post('home_videos', self.video)
            .then(result => {
                self.success = true
                self.video = result.data
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    }
}
